import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-[#F5F6F7] py-3 md:py-4 px-3 border-b border-gray-200" data-id="element-54">
      <div className="max-w-2xl mx-auto" data-id="element-55">
        <div className="bg-white border-2 border-[#D4A843] rounded-xl p-3 flex items-center gap-3" data-id="element-56">
          <div className="flex-shrink-0 bg-[#F5F0E6] rounded-full p-2.5" data-id="element-57">
            <ShieldCheckIcon className="w-8 h-8 md:w-10 md:h-10 text-[#D4A843]" strokeWidth={2} data-id="element-58" />
          </div>
          <div data-id="element-59">
            <h3 className="font-black text-[#1F3D2B] text-sm md:text-base uppercase mb-0.5" data-id="element-60">
              🔒 Garantía de 7 días
            </h3>
            <p className="text-gray-700 text-xs md:text-sm font-bold leading-snug" data-id="element-61">
              Si el material no cumple tus expectativas, te devolvemos el 100%
              de tu dinero. Sin preguntas, sin vueltas.
            </p>
          </div>
        </div>
      </div>
    </section>;
}